import {
  formatISO,
  isValid,
  parseISO,
  startOfDay,
} from 'date-fns';

export function parseDateToISO(value?: unknown): string | undefined {
  if (typeof value !== 'string') {
    return undefined;
  }

  const match = value.match(/^(\d{4})-(\d{2})-(\d{2})/);

  if (!match) {
    return undefined;
  }

  const [, year, month, day] = match;
  const date = parseISO(`${year}-${month}-${day}`);

  if (!isValid(date)) {
    return undefined;
  }

  return formatISO(startOfDay(date));
}
